<script>
  import LoadingIndicator from './LoadingIndicator.svelte'

  export let label
  export let json
</script>

<div class="box">
  <div class="content">
    <details>
      <summary>{label}</summary>
      {#if json}
        <pre>{JSON.stringify(json, null, '  ')}</pre>
      {:else}
        <LoadingIndicator />
      {/if}
    </details>
  </div>
</div>
